module.exports = __webpack_public_path__ + "img/广州办公室.0488bd2a.jpg";